<script setup>
import dayjs from 'dayjs'

import { usePlanningStore } from '@/stores/planning.store'

import { useCurrencyColumnFormatter } from '@/composables/data-grid'
import { useArchive } from '@/composables/archive'
import { useChips } from '@/composables/chips'

import ListItem from '@/components/shared/ListItem.vue'
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
})

const emit = defineEmits(['click'])

const planningStore = usePlanningStore()
const { archivedChip } = useArchive()
const { getBudgetDocumentTagChips } = useChips()

const getItemName = (item) => item.name

const getItemListing = (item) => {
  if (item.listing) {
    const listing = planningStore.getListings().find(l => l.id === item.listing)
    if (listing) return listing.name
  }
  return null
}

const getItemRightLabel = (item) => useCurrencyColumnFormatter(item, 'total_vat', item.currency_ref)

const handleClick = () => {
  emit('click', props.item.id)
}
</script>

<template>
  <q-item>
    <list-item
      :key="item.id"
      class="q-pa-sm"
      hide-avatar
      border
      :border-color="item.is_estimate ? 'var(--q-warning)' : 'var(--q-positive)'"
      :caption-chips="[...getBudgetDocumentTagChips(item.tag_ids || []), (item.archived ? archivedChip : null)].filter(Boolean)"
      :disabled="item.archived"
      dense
      clickable
      @click="handleClick"
    >
      <template #label>
        <q-item-label class="text-left">
          {{ getItemName(item) }}
          <div
            v-if="getItemListing(item)"
            class="text-caption text-grey"
          >{{ getItemListing(item) }}</div>
        </q-item-label>
      </template>
      <template #right>
        <q-item-section
          avatar
          class="align-middle align-center q-px-none"
        >
          <q-item-label class="text-left">
            {{ getItemRightLabel(item) }}
          </q-item-label>
          <q-item-label caption class="text-left align-items-baseline">
            <q-icon name="mdi-calendar" class="q-mr-xs" />
            <span>{{ dayjs(item.start).format('DD/MM') }} {{ $t('common.to') }} {{ dayjs(item.end).format('DD/MM') }}</span>
          </q-item-label>
        </q-item-section>
      </template>
    </list-item>
  </q-item>
</template>
